import { IHttp } from '../http/types'

export class BaseApi {
  constructor(protected http: IHttp, private baseUrl: string) {}
  protected getUrl(url: string) {
    return `${this.baseUrl}${url}`
  }
}
